import { render, staticRenderFns } from "./WeblogCard.vue?vue&type=template&id=3dc4403d&scoped=true"
import script from "./WeblogCard.vue?vue&type=script&lang=js"
export * from "./WeblogCard.vue?vue&type=script&lang=js"
import style0 from "./WeblogCard.vue?vue&type=style&index=0&id=3dc4403d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc4403d",
  null
  
)

export default component.exports